import React, { useState, useEffect } from "react";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../component/Baseurl";

function AgentPaymentRequest() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchTopUpRequests = async () => {
      try {
        const res = await axios.get(`${baseurl}getPendingAgentTopUps`);
        if (res.data.message === "Pending agent top-up requests fetched successfully.") {
          setRequests(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching top-up requests:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTopUpRequests();
  }, []);



  const handleGrantRequest = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You want to grant this top-up request?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, grant it!",
    });
  
    if (confirm.isConfirmed) {
      try {
        console.log("Sending grant request for ID:", id);
  
        const res = await axios.post(`${baseurl}GrantTopUpRequestToAgentByAdmin/${id}`);
        console.log(res);
  
        if (res.status === 200 || res.status === 201) {
          await Swal.fire({
            title: "Success",
            text: "Request granted successfully!",
            icon: "success",
            confirmButtonText: "OK",
          });
  
          // Reload the page after confirmation
          window.location.reload();
        }
      } catch (err) {
        Swal.fire("Error", "Failed to grant the request", "error");
        console.error("Grant request error:", err);
      }
    }
  };
  







  const filteredRequests = requests.filter(
    (req) =>
      req.transaction_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      req.user_id.toString().includes(searchTerm)
  );

  return (
    <div className="App" style={{ display: "flex" }}>
      <Sidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <BreadCrumb />
        <div className="container-fluid">
          <div className="crdmain mb-2">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="chart-title mb-0">Pending Agent Top-Up Requests</h2>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <input
                  type="text"
                  className="input1"
                  placeholder="Search by transaction ID or agent ID"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="table-responsive classic-table">
              <table className="table table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <th>#</th>
                    <th>Agent ID</th>
                    <th>Amount</th>
                    <th>Transaction ID</th>
                    {/* <th>Request To</th> */}
                    <th>Reason</th>
                    <th>Created At</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="9" className="text-center">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                  ) : filteredRequests.length === 0 ? (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No pending requests found.
                      </td>
                    </tr>
                  ) : (
                    filteredRequests.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.user_id}</td>
                        <td>{item.amount}</td>
                        <td>{item.transaction_id}</td>
                        {/* <td>{item.request_to}</td> */}
                        <td>{item.transaction_reason}</td>
                        <td>{new Date(item.created_at).toLocaleString()}</td>
                        <td>{item.status}</td>
                        <td>
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() => handleGrantRequest(item.id)}
                          >
                            Grant
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div> 
      </div>
    </div>
  );
}

export default AgentPaymentRequest;
